import React from 'react';
import { SimpleGrid, Heading, Container } from '@hover/blueprint';
import { ROOFING_MATERIALS } from '../../../constants';
import MaterialDetails from './MaterialDetails';
import { IRoofingMaterial } from '../../../interfaces/IRoofingMaterial';

const RoofingMaterials: React.FC = () => (
  <Container
    px={{ base: 500, tablet: '56px' }}
    maxW="1312px"
    centerContent
    mb={1000}
  >
    <Heading as="h2" size={{ base: 500, tablet: 600, desktop: 700 }} isLight>
      Roofing Materials
    </Heading>
    <Heading
      as="p"
      maxW="5xl"
      textAlign={{ base: 'center', desktop: 'center' }}
      marginBottom={{ base: 800, tablet: '80px' }}
      size={{ base: 300, tablet: 500 }}
      isDisplay
    >
      The purpose of calculating the precise measurements of a roof is to ensure
      you order the appropriate amount of roofing materials – whether it’s for a
      shingle, metal, and any other type of roof. Here are common roofing
      materials and considerations.
    </Heading>
    <SimpleGrid columns={{ base: 1, desktop: 3 }} spacing="60px" maxW="1089px">
      {ROOFING_MATERIALS.map((material: IRoofingMaterial) => (
        <MaterialDetails
          body={material.body}
          title={material.title}
          key={material.id}
        />
      ))}
    </SimpleGrid>
  </Container>
);

export default RoofingMaterials;
